
import GenericListTab from "./../../factories/generic-list-tab";
import TabPage from "./../../factories/tab-page";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";

/*
 * ViewModel for a list displaying fields for ShiftbookTab (bypass)
 * */
class ShiftbookTabField extends GenericListTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.IsBypassBook(ko.unwrap(parent?.IsBypassBook));
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            var key = ko.unwrap(button.ActionKey);
            if (key === "ShiftbookTabFieldMoveUp" || key === "ShiftbookTabFieldMoveDown") {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }

    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(action.ActionKey);
        if (key === "ShiftbookTabFieldMoveUp") {
            this.moveShiftbookTabField("MoveUp");
        }
        else if (key === "ShiftbookTabFieldMoveDown") {
            this.moveShiftbookTabField("MoveDown");
        }
    };

    protected moveShiftbookTabField = (action: string) => {
        this.TabPage.IsLoading(true);
        var selection = this.Selection();
        var guidList = [];
        ko.utils.arrayForEach(selection, function (item) {
            guidList.push(ko.unwrap(item.ShiftbookTabFieldId));
        });
        Bao.post("ShiftbookTabField/ShiftbookTabField" + action, JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: guidList
        }))
            .then(_ => this.Get())
            .then(_ => this.TabPage.DirtyFlag(true));
    };

    PageSize = ko.observable(0);

    SaveAllowed: KnockoutObservable<boolean>;
    IsBypassBook = ko.observable(false);


    ControllerUrl = "ShiftbookTabField";

    CustomFilter(): Models.HashObject[] {
        return null;
    }

    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }

    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }

    link = (index: number, model) => {
        this.Edit(model);
    }

}
export default ShiftbookTabField;